import { get, post } from '@classic/Foundation/Services/ApiService'
import type { LoadBetDetails } from '@core/Areas/ShareBet/LoadBet/types'

export const postShareBetDataAndGenerateLink = (
  bets: LoadBetDetails[]
): Promise<{ message: string; link: string }> => {
  return post({
    url: '/api/sharebet/share-bet',
    body: { data: bets },
  })
}

export const getShareBetDataWithKey = (
  key: string
): Promise<{ message: string; key: string; data: LoadBetDetails[]; accountNumber: string }> => {
  return get({
    url: `/api/sharebet/share-bet?key=${key}`,
  })
}
